// extracted by mini-css-extract-plugin
module.exports = {"authPage":"AuthPage_authPage__4I4kD","topBar":"AuthPage_topBar__1T8We","block":"AuthPage_block__2vQM8"};